module.exports = __webpack_public_path__ + "img/logo_idntimes.a124b008.png";